// getActiveTimers - Gets loggedin users members and return active timers across shared projects

import gql from "graphql-tag";

export const GET_ACTIVE_TIMERS = gql`
  query {
    activeTimers {
      _id
      title
      description
      details
      fist_bump {
        _id
      }
      time {
        start
        paused {
          time
          continue
        }
      }
      project {
        _id
        title
        color
      }
      created_by {
        _id
        full_name
        avatar
        email
      }
    }
  }
`;
